<!--
  Landingpage „Bierautomat“. Eigener Winkel: Alkohol rechtssicher (Alters-
  verifikation) & ungekühlt verkaufen. Live: Automatenkiosk Langenargen.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🍺</div>
      <span class="lp-eyebrow" i18n="@@bier.hero.eyebrow">Getränke-Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@bier.hero.h1">Bierautomat kaufen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@bier.hero.lead">
        Verkaufe Flaschen- und Dosenbier rund um die Uhr – rechtssicher mit Altersverifikation und
        ohne Kühlung. Die <span class="tm">marktbox</span> ist dein Bierautomat für Brauerei, Hofverkauf
        und Automatenkiosk.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bier.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#recht" (click)="scrollTo($event, 'recht')" i18n="@@bier.hero.ctaAnchor">Alkohol rechtssicher? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Bierautomat mit Altersverifikation für die Direktvermarktung" i18n-alt="@@bier.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@bier.hero.badge">🔞 mit Altersverifikation</span>
    </figure>
  </div>
</section>

<!-- ===== Alkohol rechtssicher (eigener Kern) ===== -->
<section id="recht" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@bier.recht.h2">Alkohol rechtssicher verkaufen</h2>
    <p class="lp-intro reveal" i18n="@@bier.recht.intro">
      Bier am Automaten geht – wenn der Jugendschutz sitzt. Die marktbox ist mit Altersverifikation
      erhältlich, sodass Alkohol nur nach Altersnachweis ausgegeben wird.
    </p>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🔞</span>
        <h3 i18n="@@bier.card1.h3">Altersverifikation</h3>
        <p i18n="@@bier.card1.p">Mit Altersprüfung gibt der Automat Bier nur an Berechtigte aus – jugendschutzkonform.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🌡️</span>
        <h3 i18n="@@bier.card2.h3">Ohne Kühlung – robuster &amp; günstiger</h3>
        <p i18n="@@bier.card2.p">Ein ungekühlter Automat ist weniger störanfällig und nur etwa halb so teuer wie ein Kühlautomat. Und oft zählt einfach, dass es ein Bier gibt – nicht, wie kalt es ist.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📦</span>
        <h3 i18n="@@bier.card3.h3">Auch Bündel &amp; Sixpacks</h3>
        <p i18n="@@bier.card3.p">Von der Einzelflasche bis zum 6er-Träger – die Fächer sind flexibel belegbar.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">💳</span>
        <h3 i18n="@@bier.card4.h3">Bargeldlos &amp; nachweisbar</h3>
        <p i18n="@@bier.card4.p">Kartenzahlung am Automaten – jede Transaktion ist digital dokumentiert.</p>
      </div>
    </div>
    <p class="lp-fineprint reveal" i18n="@@bier.recht.fine">
      Worauf du rechtlich achten musst:
      <a [routerLink]="['/', links.blog, blogAlkohol]">Ratgeber: Alkoholisches in Automaten verkaufen</a>
    </p>
  </div>
</section>

<!-- ===== Live-Link: Automatenkiosk Langenargen ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@bier.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@bier.live.h2">Sieh, was gerade verfügbar ist</h2>
      <p class="lp-lead" i18n="@@bier.live.lead">
        Jede marktbox hat ihren eigenen Live-Link – hier am Beispiel des Automatenkiosks Langenargen,
        wo die marktbox neben weiteren Automaten läuft.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@bier.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@bier.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@bier.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bier.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Automatenkiosk Langenargen: Echtzeit-Verfügbarkeit" i18n-title="@@bier.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@bier.live.cap">Live-Beispiel: Automatenkiosk Langenargen</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@bier.price.h2">Bierautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@bier.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@bier.price.buyText">Einmalige Investition – ideal für den dauerhaften Betrieb an Brauerei oder Kiosk.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@bier.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@bier.price.rentText">Planbare Kosten, niedrige Einstiegshürde – gut zum Testen eines Standorts.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bier.price.cta">Zum Shop – Bierautomat konfigurieren</a>
    </div>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@bier.mod.h2">Passende Modelle</h2>
    <div class="lp-models">
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="lp-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Bierautomat mit 39 Fächern" i18n-alt="@@bier.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@bier.mod39.text">39 Fächer – für breites Getränkesortiment und Bündel.</p>
          <span class="lp-model__more" i18n="@@bier.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="lp-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Bierautomat mit 24 Fächern" i18n-alt="@@bier.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@bier.mod24.text">24 Fächer – kompakter Einstieg für Hof oder Kiosk.</p>
          <span class="lp-model__more" i18n="@@bier.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@bier.faq.h2">Häufige Fragen zum Bierautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@bier.final.h2">Bereit für deinen Bierautomaten?</h2>
    <p class="lp-lead" i18n="@@bier.final.lead">Rechtssicher mit Altersverifikation, ungekühlt und 24/7 – finde dein Modell.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bier.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
